import {
  useState
} from "react";
import {
  useNavigate
} from "react-router-dom";
import {
  ShieldPlus,
  ArrowLeft
} from "lucide-react";

import RoleForm from "../components/RoleForm";
import {
  createRole
} from "../api/roleApi";

import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Button
} from "../components/ui";
import {
  useToast
} from "../context/ToastContext";

const CreateRole = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleCreateRole = async (formData) => {
    try {
      setLoading(true);

      await createRole(formData);

      navigate("/roles");
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Failed to create role"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-3 sm:p-6 lg:p-8 max-w-3xl mx-auto space-y-5">
      {/* Header Bar */}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between border-b border-neutral-200 dark:border-neutral-800 pb-4">
        <div className="flex items-center gap-2.5">
          <div>
            <h1 className="text-xl sm:text-2xl font-bold text-neutral-900 dark:text-neutral-100 tracking-tight">
              Create Role
            </h1>
            <p className="text-sm text-neutral-400 dark:text-neutral-500 mt-0.5">
              Configure user permissions and role definitions for your school platform.
            </p>
          </div>
        </div>

        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => navigate("/roles")}
          leftIcon={<ArrowLeft className="h-3.5 w-3.5" />}
          className="w-fit text-xs text-neutral-600 dark:text-neutral-300 hover:text-neutral-900 dark:hover:text-neutral-100"
        >
          Back to Roles
        </Button>
      </div>

      {/* Error Feedback */}
      

      {/* Main Card Container */}
      <Card className="border border-neutral-200 dark:border-neutral-800 shadow-none">
        <CardHeader className="border-b border-neutral-100 dark:border-neutral-800 bg-neutral-50/50 dark:bg-neutral-900/50 px-4 py-3">
          <CardTitle className="text-xs font-semibold text-neutral-700 dark:text-neutral-200 uppercase tracking-wider">
            Role Configuration & Permissions
          </CardTitle>
        </CardHeader>

        <CardContent className="p-4 sm:p-6">
          <RoleForm
            onSubmit={handleCreateRole}
            loading={loading}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default CreateRole;